import { motion } from "framer-motion";

export default function NewsletterCTA() {
  return (
    <section className="relative py-16 bg-black sm:py-20">
      {/* Dotted background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.12)_1px,transparent_1px)] [background-size:16px_16px]" />

      {/* Decorative arcs (subtle) */}
      <div className="absolute -top-20 -left-20 w-60 h-60 rounded-full border-8 border-emerald-600/30" />
      <div className="absolute -right-24 -bottom-24 w-64 h-64 rounded-full border-8 border-emerald-600/20" />

      <div className="relative px-6 mx-auto max-w-3xl text-center">
        <motion.h2
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl font-extrabold leading-tight text-emerald-400 sm:text-3xl md:text-4xl"
        >
          Get agent training updates, commission
          <br className="hidden sm:block" /> opportunities & industry insights
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1, duration: 0.5 }}
          className="mt-3 text-sm text-gray-300 md:text-base"
        >
          Stay ahead of the curve with exclusive access to new training programs, commission updates, 
          and industry insights that will help you maximize your earning potential.
        </motion.p>

        <motion.form
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.5 }}
          onSubmit={(e) => e.preventDefault()}
          className="flex gap-2 items-center p-2 mx-auto mt-6 w-full max-w-2xl bg-white rounded-xl shadow-lg"
        >
          <input
            type="email"
            placeholder="Enter your email address"
            className="flex-1 px-4 w-full h-12 text-sm text-gray-900 rounded-lg placeholder:text-gray-400 focus:outline-none"
          />
          <button
            type="submit"
            className="px-6 h-12 font-semibold text-white bg-emerald-600 rounded-lg transition shrink-0 hover:bg-emerald-500"
          >
            Submit
          </button>
        </motion.form>
      </div>
    </section>
  );
}
